var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _path5, _path6, _path7, _rect4, _path8, _rect5, _path9, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistencePoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 147,
    viewBox: "0 0 284 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFC844"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7964 53.9649C38.6118 52.0045 41.3889 52.0045 42.2042 53.9649L45.0832 60.8866C45.4269 61.7131 46.2041 62.2778 47.0963 62.3493L54.569 62.9484C56.6854 63.118 57.5435 65.7592 55.9311 67.1405L50.2377 72.0174C49.5579 72.5997 49.2611 73.5134 49.4688 74.3841L51.2082 81.6761C51.7008 83.7413 49.4541 85.3737 47.6422 84.2669L41.2445 80.3593C40.4807 79.8927 39.52 79.8927 38.7561 80.3593L32.3585 84.2669C30.5466 85.3737 28.2999 83.7413 28.7925 81.6761L30.5319 74.3841C30.7396 73.5134 30.4427 72.5997 29.7629 72.0174L24.0696 67.1405C22.4571 65.7592 23.3153 63.118 25.4317 62.9484L32.9043 62.3493C33.7965 62.2778 34.5737 61.7131 34.9175 60.8866L37.7964 53.9649Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 38,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFC844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.796 53.9649C134.612 52.0045 137.389 52.0045 138.204 53.9649L141.083 60.8866C141.427 61.7131 142.204 62.2778 143.096 62.3493L150.569 62.9484C152.685 63.118 153.544 65.7592 151.931 67.1405L146.238 72.0174C145.558 72.5997 145.261 73.5134 145.469 74.3841L147.208 81.6761C147.701 83.7413 145.454 85.3737 143.642 84.2669L137.245 80.3593C136.481 79.8927 135.52 79.8927 134.756 80.3593L128.359 84.2669C126.547 85.3737 124.3 83.7413 124.792 81.6761L126.532 74.3841C126.74 73.5134 126.443 72.5997 125.763 72.0174L120.07 67.1405C118.457 65.7592 119.315 63.118 121.432 62.9484L128.904 62.3493C129.797 62.2778 130.574 61.7131 130.917 60.8866L133.796 53.9649Z",
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 30,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFC844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.245 49.9575C230.264 47.5071 233.735 47.5071 234.755 49.9575L238.353 58.6098C238.783 59.6428 239.754 60.3487 240.87 60.4381L250.21 61.1869C252.856 61.399 253.929 64.7005 251.913 66.4271L244.796 72.5233C243.947 73.2511 243.576 74.3932 243.835 75.4815L246.009 84.5966C246.625 87.1781 243.817 89.2185 241.552 87.8351L233.555 82.9506C232.6 82.3674 231.399 82.3674 230.444 82.9506L222.447 87.8351C220.182 89.2185 217.374 87.1781 217.99 84.5966L220.164 75.4815C220.424 74.3932 220.053 73.2511 219.203 72.5233L212.086 66.4271C210.071 64.7005 211.143 61.399 213.789 61.1869L223.13 60.4381C224.245 60.3487 225.216 59.6428 225.646 58.6098L229.245 49.9575Z",
    fill: "#24284E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281 16L267 31",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272 125L281.5 135",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 115.5L185 125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 13L191 23.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 100L164.5 104L171.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 100L68.5 104L75.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 145,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistencePoints);
export default __webpack_public_path__ + "static/media/persistence-points.106676084b9017fe225676f1a43567dc.svg";
export { ForwardRef as ReactComponent };